import {Palette} from 'hubbl-shared';
import styled from 'styled-components';
import {getInitials} from './utils/getInitials';

interface InitialsAvatarProps {
  name: string;
  size?: number;
  fontSize?: number;
  backgroundColor?: string;
  color?: string;
}

export const InitialsAvatar = ({
  name,
  size = 32,
  fontSize = 12,
  backgroundColor = Palette.primaryCherokee,
  color = Palette.almostBlack,
}: InitialsAvatarProps) => {
  return (
    <Container
      $size={size}
      $fontSize={fontSize}
      $backgroundColor={backgroundColor}
      $color={color}>
      {getInitials(name)}
    </Container>
  );
};

const Container = styled.div<{
  $size: number;
  $fontSize: number;
  $backgroundColor: string;
  $color: string;
}>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: ${props => props.$size / 2}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.$backgroundColor};
  color: ${props => props.$color};
  font-weight: bold;
  font-size: ${props => props.$fontSize}px;
  line-height: 1;
  text-align: center;
  font-family: 'Poppins', sans-serif;
`;
